import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <div style={{ textAlign: 'center', paddingTop: '4rem' }}>
      <h1
        style={{
          fontSize: 'clamp(2.5rem, 6vw, 4rem)',
          marginBottom: '1rem',
          background: 'var(--gradient)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        flashcard
      </h1>
      <p
        style={{
          fontSize: '1.25rem',
          color: 'var(--text-muted)',
          maxWidth: '600px',
          margin: '0 auto 2.5rem',
        }}
      >
        Professionelle Visitenkarten in Minuten. Design hochladen oder Vorlage wählen, Daten eingeben — wir kümmern
        uns um Druck &amp; Versand.
      </p>
      <Link to="/design">
        <button className="btn btn-primary" style={{ fontSize: '1.1rem', padding: '1rem 2rem' }}>
          Jetzt starten
        </button>
      </Link>
    </div>
  );
}
